import { render, staticRenderFns } from "./detailforgetpassword.component.vue?vue&type=template&id=28f01a16&scoped=true"
import script from "./detailforgetpassword.component.vue?vue&type=script&lang=js"
export * from "./detailforgetpassword.component.vue?vue&type=script&lang=js"
import style0 from "./detailforgetpassword.component.vue?vue&type=style&index=0&id=28f01a16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f01a16",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VBtn,VCard,VDivider})
